<template>
  <v-container id="master-user" fluid tag="section" class="cyber-page">
    <v-row>
      <v-col cols="12" md="4">
        <base-material-card
          color="#018C74"
          icon="mdi-account-cog-outline"
          class="glass-card"
        >
          <template v-slot:heading>
            <div class="display-1 font-weight-black cyber-text">{{ formTitle }}</div>
          </template>

          <v-form ref="form" class="mt-4">
            <v-row dense>
              <v-col cols="12">
                <v-switch
                  v-model="editedItem.is_active"
                  :label="`STATUS: ${editedItem.is_active == 1 ? 'AKTIF' : 'NON-AKTIF'}`"
                  :true-value="1"
                  :false-value="0"
                  color="#018C74"
                  inset
                ></v-switch>
              </v-col>

              <v-col cols="12">
                <v-select
                  v-model="editedItem.role_id"
                  :items="[
                    { text: 'ADMINISTRATOR', value: 1 },
                    { text: 'OPERATOR', value: 2 },
                    { text: 'OPERATOR SEKOLAH', value: 3 },
                    { text: 'OPERATOR DESA', value: 4 },
                  ]"
                  item-text="text"
                  item-value="value"
                  label="HAK AKSES (ROLE)"
                  outlined
                  color="#CFA22D"
                  prepend-inner-icon="mdi-shield-check-outline"
                ></v-select>
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.nama"
                  label="NAMA LENGKAP"
                  outlined
                  color="#018C74"
                  prepend-inner-icon="mdi-account-outline"
                />
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.username"
                  label="USERNAME"
                  outlined
                  color="#018C74"
                  prepend-inner-icon="mdi-identifier"
                  :disabled="editedIndex > -1"
                />
              </v-col>

              <v-col cols="12">
                <v-text-field
                  v-model="editedItem.password"
                  label="PASSWORD"
                  type="password"
                  outlined
                  color="#CFA22D"
                  prepend-inner-icon="mdi-lock-outline"
                  :hint="editedIndex > -1 ? 'Kosongkan jika tidak ganti' : 'Wajib diisi'"
                  persistent-hint
                />
              </v-col>
            </v-row>

            <v-card-actions class="px-0 pt-4">
              <v-btn text color="#6b7b78" @click="clearForm">RESET</v-btn>
              <v-spacer></v-spacer>
              <v-btn
                color="#CFA22D"
                class="black--text font-weight-bold"
                :loading="loading"
                @click="save"
              >
                SIMPAN DATA
              </v-btn>
            </v-card-actions>
          </v-form>
        </base-material-card>
      </v-col>

      <v-col cols="12" md="8">
        <base-material-card
          color="#CFA22D"
          icon="mdi-database-outline"
          class="glass-card"
        >
          <v-data-table
            :headers="headers"
            :items="userList"
            :search="search"
            :loading="loading"
            class="cyber-table"
          >
            <template v-slot:item.role_name="{ item }">
              <v-chip
                small
                :color="item.role_name === 'ADMINISTRATOR' ? '#018C74' : '#607D8B'"
              >
                {{ item.role_name }}
              </v-chip>
            </template>

            <template v-slot:item.is_active="{ item }">
              <v-chip
                x-small
                outlined
                :color="item.is_active == 1 ? '#018C74' : '#FF5252'"
              >
                {{ item.is_active == 1 ? "AKTIF" : "NON-AKTIF" }}
              </v-chip>
            </template>

            <template v-slot:item.actions="{ item }">
              <v-btn icon color="#018C74" @click="editItem(item)"
                ><v-icon small>mdi-pencil</v-icon></v-btn
              >
              <v-btn icon color="#FF5252" @click="deleteItem(item)"
                ><v-icon small>mdi-delete</v-icon></v-btn
              >
            </template>
          </v-data-table>
        </base-material-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import axios from "axios";
const API_URL = "https://berkah.bondowosokab.go.id:5500/master/user";

export default {
  data: () => ({
    search: "",
    loading: false,
    userList: [],
    editedIndex: -1,
    headers: [
      { text: "NAMA", value: "nama" },
      { text: "USERNAME", value: "username" },
      { text: "ROLE", value: "role_name" },
      { text: "STATUS", value: "is_active", align: "center" },
      { text: "AKSI", value: "actions", align: "end", sortable: false },
    ],
    editedItem: {
      id: null,
      nama: "",
      username: "",
      password: "",
      role_id: 2,
      is_active: 1,
    },
    defaultItem: {
      id: null,
      nama: "",
      username: "",
      password: "",
      role_id: 2,
      is_active: 1,
    },
  }),

  computed: {
    formTitle() {
      return this.editedIndex === -1 ? "TAMBAH USER" : "EDIT USER";
    },
  },

  mounted() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const res = await axios.get(API_URL);
        this.userList = res.data.response?.data || [];
      } catch (e) {
        this.userList = [];
      } finally {
        this.loading = false;
      }
    },

    editItem(item) {
      this.editedIndex = this.userList.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.editedItem.role_id =
        item.role_name === "ADMINISTRATOR"
          ? 1
          : item.role_name === "OPERATOR"
          ? 2
          : item.role_name === "OPERATOR SEKOLAH"
          ? 3
          : 4;
      this.editedItem.password = "";
      window.scrollTo({ top: 0, behavior: "smooth" });
    },

    async save() {
      this.loading = true;
      try {
        const payload = {
          ...this.editedItem,
          is_active: Number(this.editedItem.is_active),
        };

        if (this.editedIndex > -1) {
          await axios.put(`${API_URL}/${this.editedItem.id}`, payload);
        } else {
          await axios.post(API_URL, payload);
        }
        this.fetchData();
        this.clearForm();
      } catch (e) {
        alert("Gagal simpan data");
      } finally {
        this.loading = false;
      }
    },

    async deleteItem(item) {
      if (confirm("Nonaktifkan user ini?")) {
        try {
          await axios.delete(`${API_URL}/${item.id}`);
          this.fetchData();
        } catch (e) {
          alert("Gagal hapus");
        }
      }
    },

    clearForm() {
      this.editedItem = Object.assign({}, this.defaultItem);
      this.editedIndex = -1;
    },
  },
};
</script>

<style scoped>
.cyber-page {
  background: transparent;
}
.cyber-text {
  letter-spacing: 2px !important;
  color: white !important;
  text-shadow: 0 0 10px rgba(1, 140, 116, 0.5);
}
.secondary-text {
  color: #cfa22d !important;
}
.glass-card {
  background: rgba(0, 26, 22, 0.8) !important;
  backdrop-filter: blur(12px);
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}
.cyber-save-btn {
  color: #002616 !important;
  font-weight: 900 !important;
}
.cyber-table {
  background: transparent !important;
}
.cyber-table >>> th {
  background: rgba(1, 140, 116, 0.1) !important;
  color: #cfa22d !important;
  font-weight: bold;
  border-bottom: 2px solid #018c74 !important;
}
.glow-on-hover:hover {
  filter: drop-shadow(0 0 5px currentColor);
}

.cyber-page,
.cyber-container,
.cyber-portal {
  background: transparent !important;
}

.cyber-title,
.cyber-text,
.cyber-id,
.cyber-desc,
.cyber-item-text {
  color: #1c2b28 !important;
  text-shadow: none !important;
}

.secondary-text {
  color: #018c74 !important;
  text-shadow: none !important;
}

.glass-card,
.cyber-card,
.cyber-dialog,
.cyber-dialog-card,
.cyber-modal,
.cyber-map-container,
.cyber-mapping-container,
.cyber-news-container,
.cyber-moments,
.cyber-carousel,
.cyber-agenda,
.cyber-sosmed-header,
.cyber-map-box,
.cyber-map {
  background: #ffffff !important;
  border: 1px solid #eef1f0 !important;
  backdrop-filter: none !important;
  color: #1c2b28 !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04) !important;
}

.dialog-header,
.dialog-header-gradient {
  background: #f4f7f6 !important;
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.dialog-header .white--text,
.dialog-header-gradient .white--text,
.cyber-dialog .white--text,
.cyber-dialog-card .white--text {
  color: #1c2b28 !important;
}

.dialog-neon-line,
.neon-line {
  background: linear-gradient(90deg, #018c74, #cfa22d, #018c74) !important;
}

.transparent-table,
.cyber-table,
.transparent-tabs {
  background: #ffffff !important;
  color: #1c2b28 !important;
}

.transparent-table >>> th,
.cyber-table >>> th {
  background: #f4f7f6 !important;
  color: #018c74 !important;
  font-weight: 800;
  border-bottom: 2px solid #018c74 !important;
}

.transparent-table >>> td,
.cyber-table >>> td {
  color: #1c2b28 !important;
  border-bottom: 1px solid #eef1f0 !important;
}

.transparent-table >>> .v-data-table__empty-wrapper,
.cyber-table >>> .v-data-table__empty-wrapper {
  color: #9aa6a3 !important;
}

.cyber-input,
.cyber-field,
.cyber-search,
.cyber-search-field,
.cyber-search-bar,
.cyber-input-mini,
.cyber-input-dense,
.cyber-input-highlight,
.cyber-input-coord,
.cyber-coord-field,
.cyber-select-dense,
.cyber-file-input,
.cyber-datepicker {
  color: #1c2b28 !important;
}

.cyber-input >>> .v-input__control,
.cyber-field >>> .v-input__control,
.cyber-search >>> .v-input__control,
.cyber-search-field >>> .v-input__control,
.cyber-search-bar >>> .v-input__control,
.cyber-input-mini >>> .v-input__control,
.cyber-input-dense >>> .v-input__control,
.cyber-input-highlight >>> .v-input__control,
.cyber-input-coord >>> .v-input__control,
.cyber-coord-field >>> .v-input__control,
.cyber-select-dense >>> .v-input__control,
.cyber-file-input >>> .v-input__control,
.cyber-datepicker >>> .v-input__control {
  background: #ffffff !important;
  border-radius: 10px;
}

.cyber-input >>> input,
.cyber-field >>> input,
.cyber-search >>> input,
.cyber-search-field >>> input,
.cyber-search-bar >>> input,
.cyber-input-mini >>> input,
.cyber-input-dense >>> input,
.cyber-input-coord >>> input,
.cyber-coord-field >>> input,
.cyber-datepicker >>> input,
.cyber-input >>> .v-label,
.cyber-field >>> .v-label,
.cyber-search >>> .v-label,
.cyber-search-field >>> .v-label,
.cyber-search-bar >>> .v-label,
.cyber-select-dense >>> .v-label,
.cyber-datepicker >>> .v-label {
  color: #1c2b28 !important;
}

.cyber-btn-add,
.cyber-add-btn,
.cyber-add-sosmed-btn {
  background: linear-gradient(135deg, #018c74 0%, #02b395 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border: none !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.cyber-btn-save,
.cyber-save-btn {
  background: #018c74 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
  box-shadow: 0 8px 20px rgba(1, 140, 116, 0.25) !important;
}

.icon-scan-box,
.icon-scan-frame,
.preview-container,
.preview-hex-frame,
.preview-mini-frame,
.preview-scanner {
  background: #f4f7f6 !important;
  border: 1px solid #eef1f0 !important;
}

.preview-tag {
  background: #eaf6f3 !important;
  color: #018c74 !important;
  border: 1px solid rgba(1, 140, 116, 0.3) !important;
}

.scan-overlay {
  display: none !important;
}

.shadow-glow,
.shadow-glow-gold,
.shadow-glow-teal {
  box-shadow: 0 6px 16px rgba(1, 140, 116, 0.15) !important;
}

.action-glow.edit-btn,
.action-glow.delete-btn {
  background: transparent !important;
}


.v-data-table >>> .white--text {
  color: #1c2b28 !important;
}
.plain-description {
  color: #4a5a57 !important;
}

</style>
